import type { FaireProductEntity } from "../../entity_types/product";

export const p_ne8wwz8zx9: FaireProductEntity = {
  token: "p_ne8wwz8zx9",
  type: "product",
  name: "Loose Fit V-Neck Solid Color Cardigan Sweater",
  brandToken: "b_9drv3ax8mr",
  brandName: "Plush Looks",
  imageUrl:
    "https://cdn.faire.com/fastly/2f5529f94677e37299c9994ee3cf788e268f7ac121bbcc12dbe144c93b4e6587.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f398bcc33c60232ba68ac1612286cf3873443a6913e6b4e5d970240d09ac3afd.jpeg",
    "https://cdn.faire.com/fastly/296f2c0103f6216fa22da3c3864804a9e1ca42d9a74f984a2bd36439cb34032c.jpeg",
    "https://cdn.faire.com/fastly/50b563b3505406320d1864d20e1bb284011170742350c05d149a073bc679b5b8.jpeg",
    "https://cdn.faire.com/fastly/c3efd263987fe76668bc0501e99286e7b76678c85ffd01ef5602009b9ce972a0.jpeg",
    "https://cdn.faire.com/fastly/84184aefd8d741ae89858729ea9d1f68df7cb9f6b38e0b3d410518948040ab36.jpeg",
    "https://cdn.faire.com/fastly/c54b4bd6099f2cbe2002a20f6adea5d7cb758ef7748b523965efc84d437ca66e.jpeg",
    "https://cdn.faire.com/fastly/7c34fe4c74a5d1c17256d7b0781ceabb895bd1e38206af65f09832b291cc7038.jpeg",
    "https://cdn.faire.com/fastly/a6bca904a6e18e9a66569514617c91204d425a7e90e8fe5f77e1392a4f465b8b.jpeg",
  ],
  priceDollars: 13.99,
  description:
    "\nMaterial:Chinlon,Dacron\n\nStyle:Loose,Cute,Intellectual,All-match\n\nFeature:Plain\n\nNeckline:V-neck\n\nOccasion:Going out,Casual,Artistic Retro,Girlish Sweetness,Light Maturity,Leisure Fashion\n\nSeasons:Spring,Autumn,Winter\n\nType:Sweater\n\nSleeve Length:Long Sleeve\n\nSleeve Style:Raglan Sleeve\n\nSize One_size (inch) : Bust= 39.00 ; Shoulder= 21.06 ; Sleeve= 17.55 ; Length= 23.40 ; \n\nStay cozy and stylish with our Loose Fit V-Neck Solid Color Cardigan Sweater. Made from high-quality materials, this versatile piece is perfect for layering over any outfit. The loose fit provides a relaxed and comfortable feel, while the v-neck design adds a touch of sophistication. Whether you\n",
  tags: [],
  msrpDollars: 27.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:28.356Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
